import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiTrendingUp, FiUsers, FiHome, FiBookOpen, FiGlobe, FiShield } from 'react-icons/fi';
import CountUp from 'react-countup';

interface BenefitItem {
  icon: React.ReactNode;
  titleKey: string;
  descriptionKey: string;
}

const affiliateBenefits: BenefitItem[] = [
  {
    icon: <FiTrendingUp size={24} />,
    titleKey: 'ctaAfiliacion.boostCareer',
    descriptionKey: 'ctaAfiliacion.boostCareerDesc'
  },
  {
    icon: <FiUsers size={24} />,
    titleKey: 'ctaAfiliacion.networking',
    descriptionKey: 'ctaAfiliacion.networkingDesc'
  },
  {
    icon: <FiHome size={24} />,
    titleKey: 'ctaAfiliacion.promoteProperties',
    descriptionKey: 'ctaAfiliacion.promotePropertiesDesc'
  },
  {
    icon: <FiBookOpen size={24} />,
    titleKey: 'ctaAfiliacion.continuousTraining',
    descriptionKey: 'ctaAfiliacion.continuousTrainingDesc'
  },
  {
    icon: <FiGlobe size={24} />,
    titleKey: 'ctaAfiliacion.globalConnections',
    descriptionKey: 'ctaAfiliacion.globalConnectionsDesc'
  },
  {
    icon: <FiShield size={24} />,
    titleKey: 'ctaAfiliacion.institutionalSupport',
    descriptionKey: 'ctaAfiliacion.institutionalSupportDesc'
  }
];

const stats = [
  { value: 25, suffix: '+', labelKey: 'ctaAfiliacion.yearsExperience' },
  { value: 50, suffix: '+', labelKey: 'ctaAfiliacion.annualEvents' },
  { value: 100, suffix: '%', labelKey: 'ctaAfiliacion.professionals' }
];

export default function CTAAfiliacion() {
  const { t } = useTranslation();

  return (
    <section className="py-5" style={{ backgroundColor: '#0a2f27' }}>
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column - Main CTA */}
          <div className="col-lg-5 mb-4 mb-lg-0">
            <span
              className="badge mb-3 px-3 py-2"
              style={{ backgroundColor: 'rgba(2, 222, 127, 0.2)', color: '#02de7f' }}
            >
              {t('ctaAfiliacion.badge')}
            </span>
            <h2 className="text-white fw-bold mb-3">
              {t('ctaAfiliacion.title')}
            </h2>
            <p className="text-white-50 mb-4">
              {t('ctaAfiliacion.subtitle')}
            </p>

            {/* Stats Row */}
            <div className="row g-3 mb-4">
              {stats.map((stat, index) => (
                <div className="col-4" key={index}>
                  <div className="text-center">
                    <h3 className="fw-bold mb-0" style={{ color: '#02de7f' }}>
                      <CountUp end={stat.value} duration={2} />{stat.suffix}
                    </h3>
                    <small className="text-white-50">{t(stat.labelKey)}</small>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="d-flex flex-wrap gap-3">
              <Link
                to="/list-with-us"
                className="btn btn-lg px-4"
                style={{ backgroundColor: '#02de7f', color: '#0a2f27', fontWeight: 600 }}
              >
                {t('ctaAfiliacion.affiliateNow')}
              </Link>
              <Link
                to="/beneficios"
                className="btn btn-lg btn-outline-light px-4"
              >
                {t('ctaAfiliacion.viewBenefits')}
              </Link>
            </div>
          </div>

          {/* Right Column - Benefits Grid */}
          <div className="col-lg-7">
            <div className="row g-3">
              {affiliateBenefits.map((benefit, index) => (
                <div className="col-md-6" key={index}>
                  <div
                    className="d-flex align-items-start p-3 rounded-3"
                    style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}
                  >
                    <div
                      className="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle me-3"
                      style={{
                        width: '48px',
                        height: '48px',
                        backgroundColor: 'rgba(2, 222, 127, 0.15)',
                        color: '#02de7f'
                      }}
                    >
                      {benefit.icon}
                    </div>
                    <div>
                      <h6 className="text-white fw-semibold mb-1">
                        {t(benefit.titleKey)}
                      </h6>
                      <small className="text-white-50">
                        {t(benefit.descriptionKey)}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
